<template>
  <request-form mode="Confirm" :can-back="true" @submit.prevent="doRegister" @back="toRegister">
    <text-browse-item label="発行依頼ID" :value="issuanceRequestId" />
    <text-browse-item label="ステータス" :value="statusText" />
    <datetime-browse-item label="依頼日時" :value="requestAt" />
    <text-browse-item label="依頼物件名・棟名" :value="building.name" />
    <text-browse-item label="依頼物件名・棟名（カナ）" :value="building.name_kana" />
    <text-browse-item label="依頼物件住戸番号" :value="buildingHouseNumber" />
    <text-browse-item label="所有者" :value="owner_name" />
    <postal-code-browse-item label="依頼物件郵便番号" :value="building.postal_code" />
    <text-browse-item label="依頼物件住所" :value="building.address" />
    <text-browse-item label="発行書類" :value="issueDocumentName" />
    <text-browse-item label="手数料の支払方法" :value="paymentMethodName" />
    <text-browse-with-unit-item label="請求金額" :value="billing_price" unit="円" />
    <textarea-browse-item label="備考" :value="note" />
    <text-browse-item v-if="!isOwner" label="会社名" :value="company.name" />
    <text-browse-item v-if="!isOwner" label="会社住所" :value="companyAddress" />
    <textarea-browse-item label="連絡先" :value="contact" />
    <licence-browse-item v-if="!isOwner" label="免許番号" :type="company.licence_type" :number="company.licence_number" />
    <textarea-browse-item label="再発行理由" :value="reissue_reason" />
  </request-form>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";
import {convertPrefectureCodeToName} from '@/constants/prefecture';
import {convertPaymentMethodToName} from '@/constants/payment_method';
import RequestForm from '@/views/templates/forms/RequestForm';
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import DatetimeBrowseItem from "@/views/molecules/browseItems/DatetimeBrowseItem";
import PostalCodeBrowseItem from '@/views/molecules/browseItems/PostalCodeBrowseItem';
import TextBrowseWithUnitItem from '@/views/molecules/browseItems/TextBrowseWithUnitItem';
import TextareaBrowseItem from "@/views/molecules/browseItems/TextareaBrowseItem";
import LicenceBrowseItem from "@/views/molecules/browseItems/LicenceBrowseItem";

export default {
  name: 'ReissuanceRequestRegisterConfirm',
  components: {
    RequestForm,
    TextBrowseItem,
    DatetimeBrowseItem,
    PostalCodeBrowseItem,
    TextBrowseWithUnitItem,
    TextareaBrowseItem,
    LicenceBrowseItem,
  },
  inject: [
    '$constant',
  ],
  computed: {
    ...mapState('reissuance_request_form', {
      statusText: state => state.data.status_text,
      requestAt: state => state.data.request_at,
      building: state => state.data.building,
      buildingHouseNumber: state => state.data.building_house_number,
      owner_name: state => state.data.owner_name,
      billing_price: state => state.data.billing_price,
      note: state => state.data.note,
      contact: state => state.data.contact,
      reissue_reason: state => state.data.reissue_reason,
      payment_method_code: state => state.data.payment_method,
    }),
    ...mapState('account', {
      isGuest: state => state.is_guest,
      company: state => state.company,
      guestIssuanceRequestId: state => state.guest.issuance_request_id,
      guestType: state => state.guest_type,
    }),
    ...mapGetters('reissuance_request_form', [
      'issueDocumentName',
    ]),
    registerRouteName() {
      return this.isGuest ? 'GuestReissuanceRequestRegister' : 'ReissuanceRequestRegister';
    },
    acceptedRouteName() {
      return this.isGuest ? 'GuestReissuanceRequestRegisterAccepted' : 'ReissuanceRequestRegisterAccepted';
    },
    companyAddress() {
      return convertPrefectureCodeToName(this.company.prefecture_code) + this.company.address1 + (this.company.address2 ?? '');
    },
    issuanceRequestId() {
      return this.isGuest ? this.guestIssuanceRequestId : Number(this.$route.params.id);
    },
    paymentMethodName() {
      return convertPaymentMethodToName(this.payment_method_code);
    },
    isOwner() {
      return this.guestType === this.$constant.GUEST_TYPE.OWNER.code;
    },
  },
  mounted() {
    if (this.$store.state.reissuance_request_form.data.id !== this.issuanceRequestId) {
      // 画面リロードなどでモジュール内にデータが存在しない
      this.$router.push({name: this.registerRouteName, params: {id: this.issuanceRequestId}});
    }
  },
  beforeRouteLeave(to) {
    if (!to.name.match(/^((Guest)?ReissuanceRequestRegister|(Guest)?ReissuanceRequestRegisterAccepted)$/)) {
      // 遷移先が想定された場所以外なら入力内容をリセットする
      this.resetData();
    }
  },
  methods: {
    ...mapMutations('reissuance_request_form', [
      'resetData',
    ]),
    async doRegister() {
      if (this.isGuest){
        await this.$store.dispatch('account/authGuest', {
          access_key: sessionStorage.getItem('accessKey')
        }).catch((reason) => this.$root.failApi(reason));
      }
      this.$store.dispatch('reissuance_request_form/register').then(() => {
        this.$router.push({name: this.acceptedRouteName, params: {id: this.issuanceRequestId}});
      }).catch((reason) => {
        if (reason?.handled) {
          this.$router.push({name: this.registerRouteName, params: {id: this.issuanceRequestId}});
        } else {
          this.$root.failApi();
        }
      });
    },
    toRegister() {
      this.$router.push({name: this.registerRouteName, params: {id: this.issuanceRequestId}});
    }
  }
}
</script>
